import React from 'react';
import PropTypes from 'prop-types';

import Table from '@appComponents/Table';

import {argosJobLiveControlTableRowRenderer} from './argosJobLiveControlTableRowRenderer';
import {getRowClassname} from './utils';

export const argosJobLiveControlTableColumns = {
    'event_start_datetime': {
        label: 'Event time',
        sorting: row => row.event_start_datetime,
        className: '--noWrap-time',
    },
    'event': {label: 'Event', sorting: false},
    'argos_job_definition': {
        label: 'Job definition',
        sorting: row => row.argos_job_definition_name,
    },
    'argos_job_region': {
        label: 'Region',
        sorting: row => row.argos_job_region_name,
    },
    'srt_origin_entry_point': {
        label: 'Entry point',
        sorting: row => row.srt_origin_entry_point_name,
    },
    'third_party_client_tunnel': {
        label: 'Output tunnel',
        sorting: row => row.third_party_client_tunnel_name,
    },
    'job_start_time': {
        label: 'Job start time',
        sorting: false,
        content: {singleLine: true},
    },
    'job_end_time': {
        label: 'Job end time',
        sorting: false,
        content: {singleLine: true},
    },
    'job_status': {
        label: 'Job status',
        sorting: false,
    },
    'stream_status': {
        label: 'Stream status',
        sorting: false,
    },
    'actions': {
        label: 'Actions',
        header: {
            align: 'center',
        },
        content: {
            align: 'center',
        },
    },
};

const ArgosJobLiveControlTable = (props) => (
    <div className='liveControl__table'>
        <Table
            name='argosJobLiveControlList'
            columns={argosJobLiveControlTableColumns}
            data={props.argosJobLiveControlList}
            noDataText='No Argos jobs found'
            rowRenderer={(column, row) => argosJobLiveControlTableRowRenderer(column, row, props.refetch)}
            loading={props.loading}
            rowClassname={getRowClassname}
            pagination={true}
            defaultPageSize={50}
        />

    </div>
);

ArgosJobLiveControlTable.propTypes = {
    argosJobLiveControlList: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    refetch: PropTypes.func,
};

export default ArgosJobLiveControlTable;
